export default __webpack_public_path__ + "static/media/FLSad.02bfa0cf.svg";